import React, { useState, useEffect, useRef } from 'react';
import { IoIosClose } from 'react-icons/io';
import ChristmasDecorations from '../christmas-decorations';
import './style.scss';

interface ChristmasTreeModalProps {
  showOnMount?: boolean;
  autoOpenPresent?: boolean;
}

export function ChristmasTreeModal({ showOnMount = true, autoOpenPresent = false }: ChristmasTreeModalProps) {
  const [isOpen, setIsOpen] = useState(showOnMount);
  const hasAutoOpened = useRef(false);
  const liveRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    setIsOpen(showOnMount);
  }, [showOnMount]);

  useEffect(() => {
    const handleGiftClick = () => {
      setIsOpen(false);
    };

    window.addEventListener('christmas-present-clicked', handleGiftClick);

    return () => {
      window.removeEventListener('christmas-present-clicked', handleGiftClick);
    };
  }, []);

  // Auto-abrir presente quando modal abre com autoOpenPresent=true
  useEffect(() => {
    if (isOpen && autoOpenPresent && !hasAutoOpened.current) {
      hasAutoOpened.current = true;
      // Aguarda modal renderizar e animar, então dispara clique automático no presente
      setTimeout(() => {
        const presentEvent = new CustomEvent('auto-open-present');
        window.dispatchEvent(presentEvent);
      }, 10100);
    }
  }, [isOpen, autoOpenPresent]);

  useEffect(() => {
    if (!isOpen || !liveRef.current) return;
    // Força reanúncio para leitores de tela ao abrir
    liveRef.current.textContent = '';
    setTimeout(() => {
      if (liveRef.current) {
        liveRef.current.textContent =
          'A árvore de Natal está sendo montada com partículas brilhantes. Um presente aparece aos pés da árvore para você e o presente se abre.';
      }
    }, 30);
  }, [isOpen]);

  const handleClose = () => {
    setIsOpen(false);
  };

  return (
    <>
      {isOpen && (
        <div
          className="christmas-tree-modal-overlay"
          role="dialog"
          aria-modal="true"
          aria-label="Árvore de Natal montando presente"
          aria-describedby="christmas-tree-description"
        >
          <div
            ref={liveRef}
            className="sr-only"
            id="christmas-tree-description"
            aria-live="assertive"
            aria-atomic="true"
            role="status"
          />
          <div className="christmas-tree-modal-content">
            <div className="christmas-tree-modal-tree">
              <ChristmasDecorations isModal={true} onModalClose={handleClose} />
            </div>
          </div>
        </div>
      )}
    </>
  );
}
